import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles((theme) => ({
  intestazione: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  riga: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  rimuovi: {
    marginTop: theme.spacing(1.5),
  },
  nota: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
}));

/**
 * One of the two lists of the reminder dialog, preavvisi or destinatari: a
 * title with its "Aggiungi" action, one row per entry with a remove button, a
 * note under the list. The "Aggiungi" action leaves when the list is full, as in
 * the mock; the last row cannot be removed, there is always one to fill.
 *
 * `campo` renders the input of a row; the rows carry their own `id`.
 */
const CampiInLista = ({
  titolo,
  etichettaAggiungi,
  etichettaRimuovi,
  righe,
  massimo,
  nota,
  onAggiungi,
  onRimuovi,
  campo,
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.intestazione}>
        <Typography variant="subtitle1" component="h4">
          {titolo}
        </Typography>
        {righe.length < massimo && (
          <Button
            type="button"
            color="primary"
            startIcon={<AddIcon />}
            onClick={onAggiungi}
          >
            {etichettaAggiungi}
          </Button>
        )}
      </div>
      {righe.map((riga, indice) => (
        <div key={riga.id} className={classes.riga}>
          {campo(riga, indice)}
          <IconButton
            aria-label={`${etichettaRimuovi} ${indice + 1}`}
            onClick={() => onRimuovi(indice)}
            disabled={righe.length === 1}
            className={classes.rimuovi}
            size="small"
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ))}
      <Typography variant="body2" component="p" className={classes.nota}>
        {nota}
      </Typography>
    </div>
  );
};

CampiInLista.propTypes = {
  titolo: PropTypes.string.isRequired,
  etichettaAggiungi: PropTypes.string.isRequired,
  etichettaRimuovi: PropTypes.string.isRequired,
  righe: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      valore: PropTypes.string.isRequired,
    }),
  ).isRequired,
  massimo: PropTypes.number.isRequired,
  nota: PropTypes.string.isRequired,
  onAggiungi: PropTypes.func.isRequired,
  onRimuovi: PropTypes.func.isRequired,
  campo: PropTypes.func.isRequired,
};

export default CampiInLista;
